import React from "react";

export default function ContactInfo() {
  const contactLinks = [
    {
      id: 1,
      iconClass: "icon-location",
      title: "Tunis Office",
      link: "#",
      description: "+(216) 71 904 013\nA01, Mont-plaisir centre d’affaire, AV Khaireddine PACHA CP 1073.\nTunis, Tunisia.",
      delay: "0s",
    },
    {
      id: 2,
      iconClass: "icon-location",
      title: "Dubai Office",
      link: "#",
      description: "+(971) 45690159\n904, The Burlington Tower – Marasi Drive, Business Bay, P.O. Box 346-504.\nDubai, UAE.",
      delay: "0.1s",
    },
    {
      id: 3,
      iconClass: "icon-location",
      title: "Tokyo Office",
      link: "#",
      description: "+(81) 3 6807 4061/4062 7th FI, Nisso 22 Bld., 1-11-10, Azabudai, Minato-ku, 106-0041. Tokyo, Japan.",
      delay: "0.2s",
    },
    {
      id: 4,
      iconClass: "icon-location",
      title: "Gatineau Office",
      link: "#",
      description: "188 Rue Montcalm #300, QC J8Y 3B7.\nGatineau, Canada.",
      delay: "0.3s",
    },
  ];

  return (
    <div className="contact-info pt-130">
      <div className="section-container">
        <div className="row">
          {contactLinks.map((item, index) => (
            <div className="col-lg-3 col-md-6 col-12" key={index}>
              <div
                className="wg-helpful style-1 wow fadeInUp"
                data-wow-delay={item.delay}
              >
                <div className="image">
                  <div className="icon">
                    <span className={item.iconClass} />
                  </div>
                </div>
                <h6>
                  <a href={item.link}>{item.title}</a>
                </h6>
                <p>
                  {item.description.split("\n").map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
